<template>
    <main-page>
        <b-card>
            Please wait redirecting to home page...
        </b-card>
    </main-page>
</template>

<script>
    export default {
        name: `home`,
        mounted() {
            if (window.location.search) {
                let params = window.location.search.replace(`?`, ``).split(`&`);
                let args = {};
                for (let i = 0; i < params.length; i++) {
                    args[params[i].split(`=`)[0]] = params[i].split(`=`)[1];
                }

                if (args.dealer) {
                    localStorage.setItem(`dealer`, args.dealer);
                    this.$store.commit(`setDealer`, args.dealer);
                } else {
                    localStorage.removeItem(`dealer`);
                    this.$store.commit(`setDealer`, null);
                }
                if (args.session) {
                    localStorage.setItem(`session`, args.session);
                    this.$store.commit(`setSession`, args.session);
                } else {
                    localStorage.removeItem(`session`);
                    this.$store.commit(`setDealer`, null);
                }
                this.$router.push(`/`);
            }
        }
    }
</script>

<style scoped>

</style>
